import type { ReactNode } from 'react';

type FooterColumnProps = {
  children: ReactNode;
  className?: string;
  title: string;
};

export default function FooterColumn({
  children,
  className = '',
  title
}: FooterColumnProps) {
  return (
    <section
      className={`flex flex-col gap-4 border-b border-grey-read pb-6 desktop:gap-6 ${className}`}
    >
      <h2 className="uppercase text-grey-hide">{title}</h2>
      {children}
    </section>
  );
}
